import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import FlowSelector from '../pages/FlowSelector';
import logo from '../assets/logo.png';
import FAQManagerDialog from './FAQManagerDialog';
import { useFlowContext } from '../context/FlowContext';
import axios from 'axios';
import SaveFlowModal from './SaveFlowModal';

const API_BASE = 'http://10.0.9.7:3001';

const Header = ({ flowName, onFlowNameChange, onSaveFlow, onLoadFlow, onAddCondition, startNode, setStartNode, nodes }) => {
  const location = useLocation();
  const isFlowBuilder = location.pathname.includes('/builder');
  const [isEditingName, setIsEditingName] = useState(false);
  const [isFlowSelectorOpen, setIsFlowSelectorOpen] = useState(false);
  const { userId, flowId, userGroup } = useFlowContext();
  const [faqOpen, setFaqOpen] = useState(false);
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);

  const handleNameClick = () => {
    setIsEditingName(true);
  };

  const handleNameBlur = () => {
    setIsEditingName(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      setIsEditingName(false);
    }
  };

  const handleSelectFlow = (flow) => {
    console.log('Selected flow:', flow);
    // Pass the flow object to the parent component's load flow handler
    onLoadFlow(flow);
    setIsFlowSelectorOpen(false);
  };

  const handleApplyChanges = async () => {
    if (!userId || !flowId) {
      alert('No flow selected.');
      return;
    }
    // Check if flow_name exists
    try {
      const metaRes = await axios.get(`${API_BASE}/api/flows/${userId}/${flowId}/meta`);
      if (!metaRes.data.flow_name) {
        alert('Please save the flow before applying changes.');
        return;
      }
      if (!window.confirm('Are you sure you want to apply changes? This will run the backend script.')) return;
      // Run the apply endpoint
      const applyRes = await axios.post(`${API_BASE}/api/flows/${userId}/${flowId}/apply`);
      if (applyRes.data.success) {
        alert('Apply changes succeeded!\n' + (applyRes.data.output || ''));
      } else {
        alert('Apply changes failed.');
      }
    } catch (err) {
      alert('Apply changes failed: ' + (err.response?.data?.error || err.message));
    }
  };

  return (
    <header className="header">
      <div className="brand">
        <img src={logo} alt="astTECS Logo" />
        <span className="brand-title">Flow Builder</span>
      </div>
      <div className="header-actions">
        {isFlowBuilder ? (
          <>
            <div className="flow-name-container" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              {isEditingName ? (
                <input
                  type="text"
                  value={flowName}
                  onChange={(e) => onFlowNameChange(e.target.value)}
                  onBlur={handleNameBlur}
                  onKeyPress={handleKeyPress}
                  autoFocus
                  className="flow-name-input"
                  placeholder="Untitled"
                />
              ) : (
                <span
                  className="flow-name"
                  onClick={handleNameClick}
                  style={{
                    color: flowName ? 'inherit' : '#999',
                    fontStyle: flowName ? 'normal' : 'italic',
                    cursor: 'pointer'
                  }}
                >
                  {flowName || "Untitled"}
                </span>
              )}
              {/* Start Node Dropdown */}
              <label htmlFor="startNodeSelect" style={{ fontWeight: 600, color: '#F7C59F' }}>Start Node:</label>
              <select
                id="startNodeSelect"
                value={startNode || ''}
                onChange={e => setStartNode(e.target.value)}
                disabled={(userGroup || 'user').toLowerCase() === 'user'}
                style={{
                  padding: '0.3rem',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  minWidth: '140px',
                  opacity: (userGroup || 'user').toLowerCase() === 'user' ? 0.6 : 1,
                  cursor: (userGroup || 'user').toLowerCase() === 'user' ? 'not-allowed' : 'pointer'
                }}
              >
                {nodes && nodes.map(node => (
                  <option key={node.id} value={node.id}>
                    {node.data.label || node.id}
                  </option>
                ))}
              </select>
              {/* Button order: Manage Intent, FAQ, Save Flow, Apply Changes */}
              {(userGroup || 'user').toLowerCase() === 'superadmin' && (
                <button
                  className="btn btn-secondary"
                  onClick={onAddCondition}
                  style={{
                    marginLeft: '1rem'
                  }}
                >
                  Manage Intent
                </button>
              )}
              <button className="btn btn-secondary" onClick={() => setFaqOpen(true)} style={{ marginLeft: '0.5rem' }}>FAQ</button>

              <button
                className="btn btn-primary"
                onClick={() => {
                  if ((userGroup || 'user').toLowerCase() === 'superadmin') {
                    setIsSaveModalOpen(true);
                  } else {
                    // Admin/User: Save directly for their organisation (flow_active = 0)
                    onSaveFlow({ flow_active: 0 });
                  }
                }}
                style={{ marginLeft: '0.5rem' }}
              >
                Save Flow
              </button>
              <button className="btn btn-danger" onClick={handleApplyChanges} style={{ marginLeft: '0.5rem', background: '#d32f2f', color: '#fff', border: 'none', fontWeight: 600 }}>Apply Changes</button>
            </div>
          </>
        ) : null}
      </div>

      {isFlowSelectorOpen && (
        <FlowSelector
          onClose={() => setIsFlowSelectorOpen(false)}
          onSelectFlow={handleSelectFlow}
          isModal={true}
        />
      )}
      {faqOpen && (
        <FAQManagerDialog
          open={faqOpen}
          onClose={() => setFaqOpen(false)}
          userId={userId}
          flowId={flowId}
        />
      )}
      <SaveFlowModal
        isOpen={isSaveModalOpen}
        onClose={() => setIsSaveModalOpen(false)}
        onSave={(saveData) => onSaveFlow(saveData)}
        currentUserId={userId}
      />
    </header>
  );
};

export default Header;


